import { supabase } from '@/lib/supabase';

export async function getMfaAssurance() {
  const { data, error } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel();
  if (error) throw error;

  return data;
}

export async function requiresMfaElevation() {
  const assurance = await getMfaAssurance();
  return assurance?.nextLevel === 'aal2' && assurance.currentLevel !== 'aal2';
}

export async function elevateMfaSession(code: string) {
  const assurance = await getMfaAssurance();
  if (assurance?.currentLevel === 'aal2') return;

  if (!code.trim()) {
    throw new Error('Enter the six-digit code from your authenticator app to continue.');
  }

  const { data: factors, error: factorsError } = await supabase.auth.mfa.listFactors();
  if (factorsError) throw factorsError;

  const factor = factors?.totp.find((candidate) => candidate.status === 'verified');
  if (!factor) {
    throw new Error('No verified authenticator app is available for this account.');
  }

  const { data: challenge, error: challengeError } = await supabase.auth.mfa.challenge({
    factorId: factor.id,
  });
  if (challengeError) throw challengeError;

  const { error: verifyError } = await supabase.auth.mfa.verify({
    factorId: factor.id,
    challengeId: challenge.id,
    code: code.trim(),
  });
  if (verifyError) throw verifyError;
}
